import baseHttpService from "core/http/singleton/base";

import { LocationItem } from "./resTypes";

import { getProvinceUrl, getDistrictUrl, getWardUrl } from "./urls";

export const getProvinceApi = async (): Promise<LocationItem[]> => {
  const res = await baseHttpService.get<LocationItem[]>(getProvinceUrl());
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getDistrictApi = async (
  provinceCode: string
): Promise<LocationItem[]> => {
  const res = await baseHttpService.get<LocationItem[]>(
    getDistrictUrl(provinceCode)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getWardApi = async (
  districtCode: string
): Promise<LocationItem[]> => {
  const res = await baseHttpService.get<LocationItem[]>(
    getWardUrl(districtCode)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
